export default "__VITE_ASSET__13311414__"